import type { SearchProduct } from '@/pages/api/products'

let cache: Promise<Array<SearchProduct>> | null = null

// Browser-side list of active products, shared by search and the cart stock check.
// Pass fresh to skip the cached copy (the cart uses it to read the latest stock).
export const loadProductFeed = (options: { fresh?: boolean } = {}): Promise<Array<SearchProduct>> => {
    if (!cache || options.fresh) {
        cache = fetch('/api/products', { cache: options.fresh ? 'no-store' : 'default' })
            .then(response => (response.ok ? response.json() : Promise.reject(new Error('Katalog tidak tersedia'))))
            .then((data: { products: Array<SearchProduct> }) => data.products)
            .catch(error => {
                cache = null
                throw error
            })
    }

    return cache
}
